import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';

export interface PublicConfig {
  featureTestZoneEnabled: boolean;
  /** `true` : un agent d'impression local pilote une vraie imprimante. */
  featurePrintAgentEnabled: boolean;
}

/**
 * Configuration publique de l'API (`GET /config/public`, sans authentification).
 * C'est la seule source de vérité côté front pour savoir si la Zone de test est
 * activée — jamais une variable d'environnement devinée côté client (voir
 * apps/api/src/modules/config/config.routes.ts et docs/cutover-cnss-sync.md).
 */
export function usePublicConfigQuery() {
  return useQuery({
    queryKey: ['config-public'],
    queryFn: async () => {
      const { data } = await apiClient.get<PublicConfig>('/config/public');
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
